<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">药品销售统计</el-menu-item>
      <el-menu-item index="2">药品收费统计</el-menu-item>
    </el-menu>
    <div slot="content">
      <DrugSalesData v-if="menuIndex == 1" />
      <DrugChargeDetails v-if="menuIndex == 2" />
    </div>
  </Card>
</template>

<script lang="js">
import DrugSalesData from "./DrugSalesData.vue"; // 药品销售
import DrugChargeDetails from "./DrugChargeDetails.vue"; // 药品收费
export default {
  name: "Drug",
  components: { DrugSalesData, DrugChargeDetails },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('drugIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('drugIndex', key);
    }
  }
};
</script>